import constants from '../constants';

const {
  TOURNAMENT_MEMBER_STATUS,
} = constants;

const TOURNAMENT_MEMBER_HISTORY_DATA = {
  [TOURNAMENT_MEMBER_STATUS.waited]: {
    id: TOURNAMENT_MEMBER_STATUS.waited,
    icon: {
      is: '$ui-more',
      attrs: {
        color: 'ui-neutral',
        class: 'rotate-90 ui-background',
      },
    },
  },
  [TOURNAMENT_MEMBER_STATUS.transfered]: {
    id: TOURNAMENT_MEMBER_STATUS.transfered,
    icon: {
      is: '$ui-check',
      attrs: {
        color: 'ui-success',
      },
    },
  },
  [TOURNAMENT_MEMBER_STATUS.ended]: {
    id: TOURNAMENT_MEMBER_STATUS.ended,
    icon: {
      is: '$ui-stop-circle',
      attrs: {
        color: 'ui-primary',
      },
    },
  },
};

export default {
  TOURNAMENT_MEMBER_HISTORY_DATA,
};
